import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CambioEstadoService {
  private hubConnection!: signalR.HubConnection;
  private apiBaseUrl = environment.apiUrl;
  constructor() { }

 startConnection(token: any): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.apiBaseUrl}estadoHub`, {
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .build();
  
    this.hubConnection
      .start()
      .then(() => {
        console.log('Conexión SignalR iniciada');
      })
      .catch(err => console.error('Error al conectar SignalR: ', err));
  
    this.hubConnection.onreconnecting(() => {
      console.warn('Reconectando SignalR...');
    });
  
    this.hubConnection.onreconnected(connectionId => {
      console.log('Reconexión exitosa, Connection ID:', connectionId);
    });
  
    this.hubConnection.onclose(err => {
      console.error('Conexión SignalR cerrada:', err);
      setTimeout(() => this.startConnection(token), 5000);
    });
  }

  onEstadoActualizado(callback: (id: string) => void): void {
    this.hubConnection.on('EstadoActualizado', (id: string) => {
      callback(id);
    });
  }
}
